import { Services } from './Services';
import { useContext } from 'react';
import { AppContext } from './AppContextProvider';

export const useService = (): Services => {
  /* istanbul ignore next */
  return useContext(AppContext).services;
};
